import { atom } from 'recoil';
import { giftCertificateProductSelector } from '../selectors/giftCertificateProductSelector';

export const giftCertificateAtom = atom({
    key: 'giftCertificate',
    default: giftCertificateProductSelector
});
